// src/components/SearchBox.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";
import { blogPosts } from "../../data/blogData";
import { FiSearch } from "react-icons/fi";

const SearchBox = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const navigate = useNavigate();

  const fuse = new Fuse(blogPosts, {
    keys: ["title", "content.value", "tags"],
    threshold: 0.3,
  });

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.trim() === "") {
      setResults([]);
      return;
    }
    const res = fuse.search(query);
    setResults(res.map((r) => r.item));
  };

  return (
    <div className="single-sidebar-widget mb-4">
      <div className="wid-title">
        <h3>Tìm Kiếm</h3>
      </div>
      <div className="search-widget">
        <form onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Nhập từ khóa tìm kiếm"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit">
            <FiSearch />
          </button>
        </form>

        {/* Kết quả tìm kiếm */}
        {results.length > 0 && (
          <div className="mt-3 search-results">
            {results.map((p) => (
              <div
                key={p.id}
                className="d-flex align-items-center mb-2 p-2 border rounded search-item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigate(`/bai-viet/${p.slug}`);
                  setResults([]); // clear results
                  setQuery(""); // clear input
                }}
              >
                <img
                  src={p.homeImg || p.image}
                  alt={p.title}
                  className="me-2"
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    borderRadius: "4px",
                  }}
                />
                <div>
                  <h6 className="mb-1">{p.title}</h6>
                  <small className="text-white">{p.date}</small>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBox;
